import React from "react";
import App from "./app/App.js";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "./Store.js";
import { positions, transitions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";
import "./index.css";
import "./assets/plugins/bootstrap/css/bootstrap.min.css";
import "./assets/css/style.min.css";
import SessionProvider from "./context/sessionContext.js";
import AttendanceProvider from "./context/attendanceContext";
import { BrowserRouter } from "react-router-dom";


const option = {
  timeout: 5000,
  position: positions.TOP_RIGHT,
  transition: transitions.SCALE,
  zIndex: 1050,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <SessionProvider>
        <AttendanceProvider>
          <AlertProvider template={AlertTemplate} {...option}>
            <App />
          </AlertProvider>
        </AttendanceProvider>
      </SessionProvider>
    </BrowserRouter>
  </Provider>
);
